<template>
  <div class="menu">
    <v-menu
      bottom
      left
      min-width="250"
    >
      <v-btn
        slot="activator"
        icon
      >
        <v-icon>more_vert</v-icon>
      </v-btn>

      <v-list>

        <v-list-tile @click.prevent="showDialog('edit')">
          <v-list-tile-action >
            <v-icon>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Edytuj</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click.prevent="showDialog('delete')">
          <v-list-tile-action>
            <v-icon>delete</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Usuń</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click.prevent="downloadPdfFile">
          <v-list-tile-action>
            <v-icon>print</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Drukuj</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { authorizePdfDownload } from '../../repository/subscriptions';
import { decodeUri, downloadInit } from '../../helpers/helpers';

export default {
  name: 'subscription-menu',
  props: ['subscriptionId'],
  computed: {},
  methods: {
    ...mapActions('subscriptions', [
      'setDialogVisbility',
    ]),
    showDialog(type) {
      this.setDialogVisbility({ type, id: this.subscriptionId });
    },
    async downloadPdfFile() {
      let file = await authorizePdfDownload(this.subscriptionId);
      file = decodeUri(file.data.data.url);
      if (file) {
        downloadInit(file);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .menu {
    position: absolute;
    right: 0;
    top: 16px;
    z-index: 1000;
    @media (min-width: 960px) {
      top: 50%;
      transform: translate(0, -50%);
    }
  }
</style>
